import * as React from "react";

const MailIcon = (props) => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title />
    <path d="M29 6H2.92a.78.78 0 0 0-.21 0l-.17.07a.65.65 0 0 0-.15.1.67.67 0 0 0-.15.14l-.06.06a.36.36 0 0 0 0 .09 1.08 1.08 0 0 0-.08.19 1.29 1.29 0 0 0-.1.25S2 7 2 7v18a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm-13 8.81L6.2 8h20.89ZM4 24V8.91l11.43 7.91a1.51 1.51 0 0 0 .18.09h.08A1.09 1.09 0 0 0 16 17a1 1 0 0 0 .41-.1h.07L28 9.79V24Z" />
  </svg>
);

export default MailIcon;
